module.exports = __webpack_public_path__ + "static/img/zhengqingsheng.ec47d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/zhengqingsheng.png
// module id = ZaUz
// module chunks = 0